import { FC } from 'react';
import styled from 'styled-components';
import { DropdownMenuItem, DropdownMenuItemProps } from '../../DropdownMenuItem';
import { ProductEnvironmentAvatar } from '../../../defaultComponents/ProductEnvironmentAvatar/ProductEnvironmentAvatar';
import { DisabledBadge } from '../../DisabledBadge/DisabledBadge';

export const StyledDropdownMenuItem = styled(DropdownMenuItem)`
  &:first-child,
  &:last-child {
    border-radius: 0;
  }
  :hover {
    background: ${(props) => props.theme.palette.primary}0F;
  }}
`;

export const WorkspaceMenuItem: FC<DropdownMenuItemProps> = ({ productEnvironment, productEnvironmentStatus, children, ...rest }) => (
  <StyledDropdownMenuItem
    leftSlot={productEnvironment && <ProductEnvironmentAvatar productEnvironment={productEnvironment}></ProductEnvironmentAvatar>}
    rightSlot={productEnvironmentStatus === 'disabled' && <DisabledBadge />}
    showCheckIconWhenSelected
    children={children}
    {...rest}
  />
);
